import styles from './PostColumn.module.css';

const PostColumn = ({ columns, children }) => {
  return (
    <div
      className={styles.column}
      style={{ maxWidth: `${100 / columns}%`, flex: `${100 / columns}%` }}
    >
      {children}
    </div>
  );
};

export default PostColumn;
